/**
 * 两点书法
 */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Toast, Modal } from 'antd-mobile'
import { fetchGet, fetchPost } from '../../utils/fetchRequest'
import { API } from '../../configs/api.config'
import { getArrayValue, getIntValue, getStrValue } from "../../utils/common";

class Calligraphy extends Component {

    constructor() {
        super()

        this.state = {
            generateScheme: null,
            urlLink: null,
            appid: null,
            username: null,
            path: null,
            extraData: null,
        }
    }

    componentDidMount() {
        document.title = '两点书法'

        Toast.loading('', 0)
        this.getServiceList()

        const wxappContext = document.getElementById('launch-btn');
        if(wxappContext) {
            wxappContext.addEventListener('launch', ($event) => {
                console.log('laucnh', $event)
            })
        }
    }

    componentWillUnmount() {
        Toast.hide()
    }

    render() {
        const { generateScheme, urlLink, appid, username, path, extraData } = this.state;
        return (
            <div style={{ position: 'relative', width: '6.3rem', height: '2.46rem' }}>
                <wx-open-launch-weapp
                    id="launch-btn"
                    username={username}
                    appid="wx1e8dc4a4fd1f1816"
                    path={path}
                    style={{position: 'absolute', background: 'transparent', width: '100vw', height: '100vh', top: 0, left: 0}}
                >
                    <script type="text/wxtag-template">
                        <div style={{ opacity: 0.3, background: 'red' }} />
                    </script>
                </wx-open-launch-weapp>
            </div>
        )
    }


    getServiceList = () => {
        let phone = this.props.userInfo.parent.userPhone
        if (phone === undefined) {
            phone = this.props.userInfo.teacher.userPhone
        }

        fetchGet(API.WRITE_CALLIGRAPHY, {
            phone: phone
        }).then(response => {
            Toast.hide()
            if (response && response.data) {
                let data = response.data
                this.setState({
                    generateScheme: getStrValue(data, 'generateScheme'),
                    urlLink: getStrValue(data, 'urlLink'),
                    appid: getStrValue(data, 'appid'),
                    username: getStrValue(data, 'username'),
                    path: getStrValue(data, 'path'),
                    extraData: getArrayValue(data, 'extraData')[0],
                })
            }
        }).catch(error => {
            Toast.hide()
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

}

let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo },
    appId: state.redUserInfo.appId,
    schoolId: state.redUserInfo.user.schoolId,
    stu: state.redUserInfo.parent.student,
    userOpenid: state.redUserInfo.userOpenid,
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Calligraphy)
